import React, {useEffect, useMemo, useState} from 'react'
import ModalAcceptContext from '@/components/ModalAcceptContext/ModalAcceptContext'

interface ModalProviderProps {
  children: any
}

const ModalAcceptProvider = ({children}: ModalProviderProps) => {
  const [modalAccept, setAcceptModal] = useState<React.ReactNode | null>(null)
  const hideAcceptModal = () => setAcceptModal(null)
  const modalAcceptIsShow = useMemo(() => modalAccept !== null, [modalAccept])

  useEffect(() => {
    if (modalAccept) {
      const modal = document.getElementById('modal-window')
      if (modal) {
        modal.style.filter = 'blur(5px)'
      } else {
        const container = document.getElementById('main')
        if (container) {
          container.style.filter = 'blur(5px)'
        }
      }
    } else {
      const modal = document.getElementById('modal-window')
      if (modal) {
        modal.style.filter = 'none'
      } else {
        const container = document.getElementById('main')
        if (container) {
          container.style.filter = 'none'
        }
      }
    }
  }, [modalAccept])

  return (
    <ModalAcceptContext.Provider
      value={{
        modalAccept,
        setAcceptModal,
        hideAcceptModal,
        modalAcceptIsShow,
      }}>
      {modalAccept}
      {children}
    </ModalAcceptContext.Provider>
  )
}

export default ModalAcceptProvider
